

export const FormPreloader =() => {
    return(
        <div className="preloader">
            <div className="preloaderCircle circle_green"></div>
            <div className="preloaderCircle circle_red"></div>
        </div>
    )
}